import { USER_PERMISSION } from '~/consts/user';
import { getStore } from '~/mobx/AppStore';

const getIsSlagAdmin = () => {
    const { userStore } = getStore();
    return userStore.user?.permissions.includes(USER_PERMISSION.COMPANY_ADMIN);
};

export default getIsSlagAdmin;
